/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, serializeCancelPendingEntriesCommand, type CancelPendingEntriesCommand, type ProblemDetails } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /accounts/{id}/entries/cancel-pending
 */
export interface CancelPendingRequestBuilder extends BaseRequestBuilder<CancelPendingRequestBuilder> {
    /**
     * CancelPendingEntries
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: CancelPendingEntriesCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * CancelPendingEntries
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CancelPendingEntriesCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CancelPendingRequestBuilderUriTemplate = "{+baseurl}/accounts/{id}/entries/cancel-pending";
/**
 * Metadata for all the requests in the request builder.
 */
export const CancelPendingRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CancelPendingRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCancelPendingEntriesCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
